import { ApiUrls } from '@/service/constants/urls';
import instance from '../Axios';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

type TPrices = { [key: string]: number };

export const getPrices = async (
    partnerSlug: string,
    tripIds: string
): Promise<TPrices | undefined> => {
    try {
        const { data } = await instance.get<TPrices>(ApiUrls.prices.root, {
            params: {
                partnerId: replaceLightframe(partnerSlug),
                trip_id: tripIds,
                include_dyn: 1,
            },
        });

        if (!data) {
            throw new Error(`[warn] Fetch min prices error!`);
        }
        return data;
    } catch (error) {
        return undefined;
    }
};
